import axios from "axios";
import session from "./session";

export default class {
  static getAll = async () => {
    let result = { data: null, error: null };
    await axios
      .post(`${process.env.REACT_APP_API_URL}/folders/all`, {
        userId: session.get("user")._id,
      })
      .then((resp) => {
        if (resp.status === 200) result.data = resp.data;
      })
      .catch((err) => {
        result.error = err.response?.data;
      });
    return result;
  };

  static create = async (name) => {
    let result = { data: null, error: null };
    await axios
      .post(`${process.env.REACT_APP_API_URL}/folders`, {
        name,
        userId: session.get("user")._id,
        date: new Date(),
      })
      .then((resp) => {
        if (resp.status === 200) result.data = resp.data;
      })
      .catch((err) => {
        result.error = err.response?.data;
      });
    return result;
  };

  static rename = async (id, name) => {
    let result = { data: null, error: null };
    await axios
      .post(`${process.env.REACT_APP_API_URL}/folders/rename/${id}`, { name })
      .then((resp) => {
        if (resp.status === 200) result.data = resp.data;
      })
      .catch((err) => {
        result.error = err.response?.data;
      });
    return result;
  };

  static delete = async (id) => {
    let result = { data: null, error: null };
    await axios
      .delete(`${process.env.REACT_APP_API_URL}/folders/${id}`)
      .then((resp) => {
        if (resp.status === 200) result.data = resp.data;
      })
      .catch((err) => {
        result.error = err.response?.data;
      });
    return result;
  };

  static updateThumbnail = async (id, url) => {
    let result = { data: null, error: null };
    await axios
      .post(`${process.env.REACT_APP_API_URL}/folders/thumbnail/${id}`, { url })
      .then((resp) => {
        if (resp.status === 200) result.data = resp.data;
      })
      .catch((err) => {
        result.error = err.response?.data;
      });
    return result;
  };

  // Bulk move. Returns {requested, matched, moved, skipped} so the caller can
  // tell the user when some projects were not theirs to move.
  static moveProjects = async (projectIds, folderId) => {
    let result = { data: null, error: null };
    await axios
      .post(`${process.env.REACT_APP_API_URL}/folders/move-projects`, {
        projectIds,
        folderId: folderId || null,
        userId: session.get("user")?._id,
      })
      .then((resp) => {
        if (resp.status === 200) result.data = resp.data;
      })
      .catch((err) => {
        result.error = err.response?.data || "Failed to move projects";
      });
    return result;
  };

  static bulkDelete = async (folderIds) => {
    let result = { data: null, error: null };
    await axios
      .post(`${process.env.REACT_APP_API_URL}/folders/bulk-delete`, {
        folderIds,
        userId: session.get("user")?._id,
      })
      .then((resp) => {
        if (resp.status === 200) result.data = resp.data;
      })
      .catch((err) => {
        result.error = err.response?.data || "Failed to delete folders";
      });
    return result;
  };

  static moveProject = async (projectId, folderId) => {
    let result = { data: null, error: null };
    await axios
      .post(`${process.env.REACT_APP_API_URL}/folders/move-project`, {
        projectId,
        folderId,
      })
      .then((resp) => {
        if (resp.status === 200) result.data = resp.data;
      })
      .catch((err) => {
        result.error = err.response?.data;
      });
    return result;
  };
}
